import React, { FC } from 'react';
import classNames from 'classnames';

import { IconCTA } from 'Src/components/buttons/IconCTA';

import styles from './CheckDetailPrintCheckBox.module.scss';

const sectionId = 'CheckDetailPrintCheckBox';

interface CheckDetailPrintCheckBoxProps {
  className?: string;
  checked?: boolean;
  onClick?: () => void;
}

const CheckDetailPrintCheckBox: FC<CheckDetailPrintCheckBoxProps> = ({
  className,
  checked,
  onClick,
  ...rest
}) => (
  <IconCTA
    {...rest}
    size="xs"
    className={classNames(styles.root, className, {
      [styles.checked]: checked,
    })}
    onClick={onClick}
    icon={{ jsx: <span className={styles.icon} /> }}
  />
);

export type { CheckDetailPrintCheckBoxProps };
export { CheckDetailPrintCheckBox, sectionId };
